import React, { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

import { ProtectedRoute } from '@packages/components/protected-route/protected-route';

import { AgentsRoutes } from './pages/agents/agents.routes';
import { CloudSensorsRoutes } from './pages/cloud-sensors/cloud-sensors.routes';
import { ScanSchedulesRoutes } from './pages/scan-schedules/scan-schedules.routes';
import { ScannersRoutes } from './pages/scanners/scanners.routes';
import { SensorRoutes } from './pages/sensors/sensors-routes';

const Overview = lazy(() => import('./pages/overview/overview.page'));
const LogSourcesPage = lazy(
  () => import('./pages/log-sources/log-sources.page'),
);
const CoverageScorePage = lazy(
  () => import('./pages/coverage-score/CoverageScore.page'),
);

export const TelemetryRoutes = () => {
  return (
    <Routes>
      <Route
        element={
          <ProtectedRoute
            legacyCapabilities={{
              canViewAgent: true,
              canViewCloudSensor: true,
              canViewScanner: true,
              canViewSensor: true,
            }}
          />
        }
      >
        <Route index element={<Overview />} />
      </Route>

      <Route
        element={<ProtectedRoute legacyCapabilities={{ canViewAgent: true }} />}
      >
        <Route path="agents/*" element={<AgentsRoutes />} />
      </Route>
      <Route
        element={
          <ProtectedRoute legacyCapabilities={{ canViewScanner: true }} />
        }
      >
        <Route path="scanners/*" element={<ScannersRoutes />} />
      </Route>
      <Route path="log-sources" element={<LogSourcesPage />} />
      <Route
        element={
          <ProtectedRoute legacyCapabilities={{ canViewSensor: true }} />
        }
      >
        <Route path="sensors/*" element={<SensorRoutes />} />
      </Route>
      <Route
        element={
          <ProtectedRoute legacyCapabilities={{ canViewCloudSensor: true }} />
        }
      >
        <Route path="cloud/*" element={<CloudSensorsRoutes />} />
      </Route>
      <Route
        element={
          <ProtectedRoute legacyCapabilities={{ canViewScanSchedules: true }} />
        }
      >
        <Route path="scan-schedules/*" element={<ScanSchedulesRoutes />} />
      </Route>
      <Route path="coverage-score" element={<CoverageScorePage />} />
    </Routes>
  );
};
